//Post Approval
export const REQUEST_APPROVAL_LIST_SUCCESS = 'REQUEST_APPROVAL_LIST_SUCCESS'
export const REQUEST_APPROVAL_LIST_FAILURE = 'REQUEST_APPROVAL_LIST_FAILURE'


export const SOCIAL_MESSAGE_VIEW_FAILURE = 'SOCIAL_MESSAGE_VIEW_FAILURE'
export const SOCIAL_MESSAGE_VIEW_SUCCESS = 'SOCIAL_MESSAGE_VIEW_SUCCESS'


// dashboard
export const REQUEST_DASHBOARD_DATA_SUCCESS = 'REQUEST_DASHBOARD_DATA_SUCCESS';

//userSetting
export const TOGGLE_USER_SETTING_POPUP = 'TOGGLE_USER_SETTING_POPUP';
export const SET_USER_SETTING_ACTIVE_TAB = 'SET_USER_SETTING_ACTIVE_TAB';

// dashboard - Health Data Table
export const REQUEST_FETCH_HEALTH_DATA_START = 'REQUEST_FETCH_HEALTH_DATA_START';
export const REQUEST_FETCH_HEALTH_DATA_FAILURE = 'REQUEST_FETCH_HEALTH_DATA_FAILURE';
export const REQUEST_FETCH_HEALTH_DATA_SUCCESS = 'REQUEST_FETCH_HEALTH_DATA_SUCCESS';
export const REQUEST_RECENT_POSTS_FAILURE = 'REQUEST_DASHBOARD_FAILURE';
export const REQUEST_RECENT_POSTS_SUCCESS = 'REQUEST_RECENT_POSTS_SUCCESS';
export const REQUEST_RECENT_POSTS_START = 'REQUEST_RECENT_POSTS_START'

export const REQUEST_FETCH_DRAFTS_SUCCESS = 'REQUEST_FETCH_DRAFTS_SUCCESS';
export const REQUEST_FETCH_DRAFTS_ERROR = 'REQUEST_FETCH_DRAFTS_ERROR';
export const REQUEST_FETCH_DRAFTS_START = 'REQUEST_FETCH_DRAFTS_START';

//example data
export const REQUEST_EXAMPLE_DATA = 'REQUEST_EXAMPLE_DATA';

export const CHANGE_BRAND = 'CHANGE_BRAND';

export const SET_DIRTY_STATE = 'SET_DIRTY_STATE'

//linkedin admins
export const REQUEST_LINKEDIN_PAGES = 'REQUEST_LINKEDIN_PAGES';
export const CLEAR_LINKED_PAGE_LIST = "CLEAR_LINKED_PAGE_LIST "

// users
export const REQUEST_CURRENT_USER_SUCCESS = 'REQUEST_CURRENT_USER_SUCCESS';
export const REQUEST_CURRENT_USER_FAILURE = 'REQUEST_CURRENT_USER_FAILURE';

// authentication
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILURE = 'REQUEST_LOGIN_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const PASSWORD_RESET_REQUEST_EMAIL_SUCCESS = 'PASSWORD_RESET_REQUEST_EMAIL_SUCCESS';
export const PASSWORD_RESET_REQUEST_EMAIL_FAILURE = 'PASSWORD_RESET_REQUEST_EMAIL_FAILURE';
export const PASSWORD_RESET_VERIFY_TOKEN_SUCCESS = 'PASSWORD_RESET_VERIFY_TOKEN_SUCCESS';
export const PASSWORD_RESET_VERIFY_TOKEN_FAILURE = 'PASSWORD_RESET_VERIFY_TOKEN_FAILURE';
export const SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_FAILURE = 'SET_NEW_PASSWORD_FAILURE';
export const CHECK_EMAIL_SUCCESS = 'CHECK_EMAIL_SUCCESS';
export const CHECK_EMAIL_FAILURE = 'CHECK_EMAIL_FAILURE';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

// snackbar
export const SHOW_SNACKBAR_SUCCESS = 'SHOW_SNACKBAR_SUCCESS';
export const SHOW_SNACKBAR_ERROR = 'SHOW_SNACKBAR_ERROR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

// profile
export const REQUEST_PROFILE_SUCCESS = 'REQUEST_PROFILE_SUCCESS';
export const REQUEST_PROFILE_FAILURE = 'REQUEST_PROFILE_FAILURE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

// cms
export const REQUEST_CMS_LIST_SUCCESS = 'REQUEST_CMS_LIST_SUCCESS';
export const REQUEST_CMS_LIST_FAILURE = 'REQUEST_CMS_LIST_FAILURE';
export const REQUEST_CMS_SUCCESS = 'REQUEST_CMS_SUCCESS';
export const REQUEST_CMS_FAILURE = 'REQUEST_CMS_FAILURE';
export const CREATE_CMS_SUCCESS = 'CREATE_CMS_SUCCESS';
export const CREATE_CMS_FAILURE = 'CREATE_CMS_FAILURE';
export const UPDATE_CMS_SUCCESS = 'UPDATE_CMS_SUCCESS';
export const UPDATE_CMS_FAILURE = 'UPDATE_CMS_FAILURE';
export const DELETE_CMS_SUCCESS = 'DELETE_CMS_SUCCESS';
export const DELETE_CMS_FAILURE = 'DELETE_CMS_FAILURE';

// captions
export const REQUEST_CAPTIONS_SUCCESS = 'REQUEST_CAPTIONS_SUCCESS';
export const REQUEST_CAPTIONS_FAILURE = 'REQUEST_CAPTIONS_FAILURE';
export const ADD_CAPTIONS_SUCCESS = 'ADD_CAPTIONS_SUCCESS';
export const ADD_CAPTIONS_FAILURE = 'ADD_CAPTIONS_FAILURE';
export const UPDATE_CAPTIONS_SUCCESS = 'UPDATE_CAPTIONS_SUCCESS';
export const UPDATE_CAPTIONS_FAILURE = 'UPDATE_CAPTIONS_FAILURE';
export const DELETE_CAPTIONS_SUCCESS = 'DELETE_CAPTIONS_SUCCESS';
export const DELETE_CAPTIONS_FAILURE = 'DELETE_CAPTIONS_FAILURE';

// user manager
export const REQUEST_ALL_USERS_SUCCESS = 'REQUEST_ALL_USERS_SUCCESS';
export const REQUEST_ALL_USERS_FAILURE = 'REQUEST_ALL_USERS_FAILURE';
export const REQUEST_USER_DETAILS_SUCCESS = 'REQUEST_USER_DETAILS_SUCCESS';
export const REQUEST_USER_DETAILS_FAILURE = 'REQUEST_USER_DETAILS_FAILURE';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const USERS_EXPORT_CSV_SUCCESS = 'USERS_EXPORT_CSV_SUCCESS';
export const USERS_EXPORT_CSV_FAILURE = 'USERS_EXPORT_CSV_FAILURE';

export const GET_OPTED_USER_BRANDS = 'GET_OPTED_USER_BRANDS';
export const GET_OPTED_USER_BRANDS_FAILURE = 'GET_OPTED_USER_BRANDS_FAILURE';

// accountManager
export const REQUEST_ACCOUNT_LIST_SUCCESS = 'REQUEST_ACCOUNT_LIST_SUCCESS';
export const REQUEST_ACCOUNT_LIST_FAILURE = 'REQUEST_ACCOUNT_LIST_FAILURE';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_FAILURE = 'CREATE_ACCOUNT_FAILURE';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE';

// BRAND Manager
export const ADD_NEW_BRAND_SUCCESS = 'ADD_NEW_BRAND_SUCCESS';
export const ADD_NEW_BRAND_FAILURE = 'ADD_NEW_BRAND_FAILURE';

// file manager
export const REQUEST_MEDIA_FILES_SUCCESS = 'REQUEST_MEDIA_FILES_SUCCESS';
export const REQUEST_MEDIA_FILES_FAILURE = 'REQUEST_MEDIA_FILES_FAILURE';
export const LOCAL_FILE_UPLOAD_SUCCESS = 'LOCAL_FILE_UPLOAD_SUCCESS';
export const LOCAL_FILE_UPLOAD_FAILURE = 'LOCAL_FILE_UPLOAD_FAILURE';
export const GET_DROPBOX_TOKEN_SUCCESS = 'GET_DROPBOX_TOKEN_SUCCESS';
export const GET_DROPBOX_TOKEN_FAILURE = 'GET_DROPBOX_TOKEN_FAILURE';
export const GET_GOOGLE_DRIVE_TOKEN_SUCCESS = 'GET_GOOGLE_DRIVE_TOKEN_SUCCESS';
export const GET_GOOGLE_DRIVE_TOKEN_FAILURE = 'GET_GOOGLE_DRIVE_TOKEN_FAILURE';
export const CLOUD_FILE_UPLOAD_SUCCESS = 'CLOUD_FILE_UPLOAD_SUCCESS';
export const CLOUD_FILE_UPLOAD_FAILURE = 'CLOUD_FILE_UPLOAD_FAILURE';
export const DELETE_FILES_SUCCESS = 'DELETE_FILES_SUCCESS';
export const DELETE_FILES_FAILURE = 'DELETE_FILES_FAILURE';
export const ADD_GOOGLE_DRIVE_CREDENTIAL_SUCCESS = 'ADD_GOOGLE_DRIVE_CREDENTIAL_SUCCESS';
export const ADD_GOOGLE_DRIVE_CREDENTIAL_FAILURE = 'ADD_GOOGLE_DRIVE_CREDENTIAL_FAILURE';
export const DELETE_GOOGLE_DRIVE_CREDENTIAL_SUCCESS = 'DELETE_GOOGLE_DRIVE_CREDENTIAL_SUCCESS'
export const ADD_DROPBOX_CREDENTIAL_SUCCESS = 'ADD_DROPBOX_CREDENTIAL_SUCCESS';
export const ADD_DROPBOX_CREDENTIAL_FAILURE = 'ADD_DROPBOX_CREDENTIAL_FAILURE';
export const GET_MEDIA_FOLDERS_SUCCESS = 'GET_MEDIA_FOLDERS_SUCCESS';
export const GET_MEDIA_FOLDERS_FAILURE = 'GET_MEDIA_FOLDERS_FAILURE';
export const SET_MEDIA_FILES_STORE = 'SET_MEDIA_FILES_STORE';

// facebookPost
export const CREATE_FACEBOOK_POST_SUCCESS = 'CREATE_FACEBOOK_POST_SUCCESS';
export const CREATE_FACEBOOK_PAGE_SUCCESS = 'CREATE_FACEBOOK_PAGE_SUCCESS';
export const CREATE_FACEBOOK_POST_FAILURE = 'CREATE_FACEBOOK_POST_FAILURE';

//InstagramPost
export const CREATE_INSTAGRAM_POST_SUCCESS = 'CREATE_INSTAGRAM_POST_SUCCESS';
export const CREATE_INSTAGRAM_PAGE_SUCCESS = 'CREATE_INSTAGRAM_PAGE_SUCCESS';
export const CREATE_INSTAGRAM_POST_FAILURE = 'CREATE_INSTAGRAM_POST_FAILURE';

//FacebookPageAnalytics
export const GET_FACEBOOK_PAGE_ANALYTICS_SUCCESS = 'GET_FACEBOOK_PAGE_ANALYTICS_SUCCESS';
export const GET_FACEBOOK_PAGE_ANALYTICS_FAILURE = 'GET_FACEBOOK_PAGE_ANALYTICS_FAILURE';

//FacebookPostAnalytics
export const GET_FACEBOOK_POST_ANALYTICS_SUCCESS = 'GET_FACEBOOK_POST_ANALYTICS_SUCCESS';
export const GET_FACEBOOK_POST_ANALYTICS_FAILURE = 'GET_FACEBOOK_POST_ANALYTICS_FAILURE';

//InstagramAccountAnalytics
export const GET_INSTAGRAM_ACCOUNT_ANALYTICS_SUCCESS = 'GET_INSTAGRAM_ACCOUNT_ANALYTICS_SUCCESS';
export const GET_INSTAGRAM_ACCOUNT_ANALYTICS_FAILURE = 'GET_INSTAGRAM_ACCOUNT_ANALYTICS_FAILURE';

//InstagramPostAnalytics
export const GET_INSTAGRAM_POST_ANALYTICS_SUCCESS = 'GET_INSTAGRAM_POST_ANALYTICS_SUCCES';
export const GET_INSTAGRAM_POST_ANALYTICS_FAILURE = 'GET_INSTAGRAM_POST_ANALYTICS_FAILURE';

//YouTubeChannelsAnalytics
export const GET_YOUTUBE_CHANNELS_ANALYTICS_SUCCESS = 'GET_YOUTUBE_CHANNELS_ANALYTICS_SUCCESS';
export const GET_YOUTUBE_CHANNELS_ANALYTICS_FAILURE = 'GET_YOUTUBE_CHANNELS_ANALYTICS_FAILURE';

//YouTubeChannels
export const CREATE_YOUTUBE_CHANNELS_SUCCESS = 'CREATE_YOUTUBE_CHANNELS_SUCCESS';
export const CREATE_YOUTUBE_CHANNELS_FAILURE = 'CREATE_YOUTUBE_CHANNELS_FAILURE';

//YouTubeVideos
export const CREATE_YOUTUBE_VIDEOS_SUCCESS = 'CREATE_YOUTUBE_VIDEOS_SUCCESS';
export const CREATE_YOUTUBE_VIDEOS_FAILURE = 'CREATE_YOUTUBE_VIDEOS_FAILURE';


//YouTubeVideosAnalytics
export const GET_YOUTUBE_VIDEOS_ANALYTICS_SUCCESS = 'GET_YOUTUBE_VIDEOS_ANALYTICS_SUCCESS';
export const GET_YOUTUBE_VIDEOS_ANALYTICS_FAILURE = 'GET_YOUTUBE_VIDEOS_ANALYTICS_FAILURE';

//LinkedInPageAnalytics
export const GET_LINKEDIN_PAGE_ANALYTICS_SUCCESS = 'GET_LINKEDIN_PAGE_ANALYTICS_SUCCESS';
export const GET_LINKEDIN_PAGE_ANALYTICS_FAILURE = 'GET_LINKEDIN_PAGE_ANALYTICS_FAILURE';

//TwitterTweetAnalytics
export const GET_TWITTER_TWEET_ANALYTICS_SUCCESS = 'GET_TWITTER_TWEET_ANALYTICS_SUCCESS';
export const GET_TWITTER_TWEET_ANALYTICS_FAILURE = 'GET_TWITTER_TWEET_ANALYTICS_FAILURE';

// twitterPost
export const CREATE_TWITTER_POST_SUCCESS = 'CREATE_TWITTER_POST_SUCCESS';
export const CREATE_TWITTER_PAGE_SUCCESS = 'CREATE_TWITTER_PAGE_SUCCESS';
export const CREATE_TWITTER_POST_FAILURE = 'CREATE_TWITTER_POST_FAILURE';

// linkedinPost
export const CREATE_LINKEDIN_POST_SUCCESS = 'CREATE_LINKEDIN_POST_SUCCESS';
export const CREATE_LINKEDIN_PAGE_SUCCESS = 'CREATE_LINKEDIN_PAGE_SUCCESS';
export const CREATE_LINKEDIN_POST_FAILURE = 'CREATE_LINKEDIN_POST_FAILURE';

// group manager
export const REQUEST_GROUP_LIST_SUCCESS = 'REQUEST_GROUP_LIST_SUCCESS';
export const REQUEST_GROUP_LIST_FAILURE = 'REQUEST_GROUP_LIST_FAILURE';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const ADD_GROUP_FAILURE = 'ADD_GROUP_FAILURE';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILURE = 'UPDATE_GROUP_FAILURE';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';

// dashboard
export const REQUEST_DASHBOARD_SUCCESS = 'REQUEST_DASHBOARD_SUCCESS';
export const REQUEST_DASHBOARD_FAILURE = 'REQUEST_DASHBOARD_FAILURE';

// user report
export const REQUEST_USER_REPORT_SUCCESS = 'REQUEST_USER_REPORT_SUCCESS';
export const REQUEST_USER_REPORT_FAILURE = 'REQUEST_USER_REPORT_FAILURE';

// package info
export const REQUEST_PACKAGE_INFO_SUCCESS = 'REQUEST_PACKAGE_INFO_SUCCESS';
export const REQUEST_PACKAGE_INFO_FAILURE = 'REQUEST_PACKAGE_INFO_FAILURE';

// subscription info
export const REQUEST_SUBSCRIPTION_INFO_SUCCESS = 'REQUEST_SUBSCRIPTION_INFO_SUCCESS';
export const REQUEST_SUBSCRIPTION_INFO_FAILURE = 'REQUEST_SUBSCRIPTION_INFO_FAILURE';

//User package info
export const REQUEST_USER_PACKAGE_INFO_SUCCESS = 'REQUEST_USER_PACKAGE_INFO_SUCCESS';
export const REQUEST_USER_PACKAGE_INFO_FAILURE = 'REQUEST_USER_PACKAGE_INFO_FAILURE';

// payment history
export const REQUEST_PAYMENT_HISTORY_SUCCESS = 'REQUEST_PAYMENT_HISTORY_SUCCESS';
export const REQUEST_PAYMENT_HISTORY_FAILURE = 'REQUEST_PAYMENT_HISTORY_FAILURE';
export const EXPORT_PAYMENT_CSV_SUCCESS = 'EXPORT_PAYMENT_CSV_SUCCESS';
export const EXPORT_PAYMENT_CSV_FAILURE = 'EXPORT_PAYMENT_CSV_FAILURE';

// schedules
export const REQUEST_SCHEDULES_SUCCESS = 'REQUEST_SCHEDULES_SUCCESS';
export const REQUEST_SCHEDULES_FAILURE = 'REQUEST_SCHEDULES_FAILURE';
export const REQUEST_GET_ALL_FILES_SUCCESS = 'REQUEST_GET_ALL_FILES_SUCCESS';

// schedules
export const REQUEST_CALENDAR_SUCCESS = 'REQUEST_CALENDAR_SUCCESS';
export const REQUEST_CALENDAR_FAILURE = 'REQUEST_CALENDAR_FAILURE';

// Queue

export const REQUEST_QUEUE_SUCCESS = 'REQUEST_QUEUE_SUCCESS';
export const REQUEST_QUEUE_FAILURE = 'REQUEST_QUEUE_FAILURE';

// social Platform
export const REQUEST_SOCIAL_PLATFORM_LIST_SUCCESS = 'REQUEST_SOCIAL_PLATFORM_LIST_SUCCESS';
export const REQUEST_SOCIAL_PLATFORM_LIST_FAILURE = 'REQUEST_SOCIAL_PLATFORM_LIST_FAILURE';
export const REQUEST_SOCIAL_PLATFORM_KEYS_SUCCESS = 'REQUEST_SOCIAL_PLATFORM_KEYS_SUCCESS';
export const REQUEST_SOCIAL_PLATFORM_KEYS_FAILURE = 'REQUEST_SOCIAL_PLATFORM_KEYS_FAILURE';
export const UPDATE_FACEBOOK_KEYS_SUCCESS = 'UPDATE_FACEBOOK_KEYS_SUCCESS';
export const UPDATE_FACEBOOK_KEYS_FAILURE = 'UPDATE_FACEBOOK_KEYS_FAILURE';
export const UPDATE_TWITTER_KEYS_SUCCESS = 'UPDATE_TWITTER_KEYS_SUCCESS';
export const UPDATE_TWITTER_KEYS_FAILURE = 'UPDATE_TWITTER_KEYS_FAILURE';
export const UPDATE_LINKEDIN_KEYS_SUCCESS = 'UPDATE_LINKEDIN_KEYS_SUCCESS';
export const UPDATE_LINKEDIN_KEYS_FAILURE = 'UPDATE_LINKEDIN_KEYS_FAILURE';

// social Page
export const REQUEST_SOCIAL_PAGES_SUCCESS = 'REQUEST_SOCIAL_PAGES_SUCCESS';
export const REQUEST_SOCIAL_PAGES_FAILURE = 'REQUEST_SOCIAL_PAGES_FAILURE';
export const UPDATE_SOCIAL_PAGES_SUCCESS = 'UPDATE_SOCIAL_PAGES_SUCCESS';
export const UPDATE_SOCIAL_PAGES_FAILURE = 'UPDATE_SOCIAL_PAGES_FAILURE';


//publish posts
export const REQUEST_FACEBOOK_POST_SUCCCESS = 'REQUEST_FACEBOOK_POST_SUCCCESS';
export const REQUEST_INSTAGRAM_POST_SUCCCESS = 'REQUEST_INSTAGRAM_POST_SUCCCESS';
export const REQUEST_YOUTUBE_VIDEOS_SUCCCESS = 'REQUEST_YOUTUBE_VIDEOS_SUCCCESS';
export const REQUEST_LINKEDIN_POST_SUCCCESS = 'REQUEST_LINKEDIN_POST_SUCCCESS';
export const REQUEST_TWITTER_POST_SUCCCESS = 'REQUEST_TWITTER_POST_SUCCCESS';
export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS';

export const REQUEST_USER_MANAGER_LIST_DATA = 'REQUEST_USER_MANAGER_LIST_DATA';
export const POST_USER_MANAGER_DATA = 'POST_USER_MANAGER_DATA';
export const EDIT_USER_MANAGER_DATA = 'EDIT_USER_MANAGER_DATA';
export const DELETE_USER_MANAGER_DATA = 'DELETE_USER_MANAGER_DATA';

export const GET_POST_APPROVAL_LIST = 'GET_POST_APPROVAL_LIST';
export const POST_APPROVAL_LIST_SUCCESS = 'POST_APPROVAL_LIST_SUCCESS';
export const CREATE_POST_APPROVAL_SUCCESS = 'CREATE_POST_APPROVAL_SUCCESS';
export const UPDATE_POST_APPROVAL_SUCCESS = 'UPDATE_POST_APPROVAL_SUCCESS';
export const CREATE_NEW_POST_SUCCESS = 'CREATE_NEW_POST_SUCCESS';
export const GET_ALL_APIS_LIST = 'GET_ALL_APIS_LIST';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';

// logs 
export const REQUEST_LOGS_LIST_SUCCESS = 'REQUEST_LOGS_LIST_SUCCESS'
export const REQUEST_LOGS_LIST_FAILURE = 'REQUEST_LOGS_LIST_FAILURE'
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD'
export const ACCOUNT_ACTIVATION_REQUEST = 'ACCOUNT_ACTIVATION_REQUEST'
export const GET_PENDING_INVOICES = 'GET_PENDING_INVOICES'

//payments 
export const MAKE_PAYMENT_FOR_SUBSCRIPTION = 'MAKE_PAYMENT_FOR_SUBSCRIPTION';
export const GET_PENDING_INVOICES_SUCCESS = 'GET_PENDING_INVOICES_SUCCESS'
export const GET_PENDING_INVOICES_ERROR = 'GET_PENDING_INVOICES_ERROR';
export const UPDATE_NEW_IMAGE = 'UPDATE_NEW_IMAGE';

//Change Display
export const FACEBOOK_PAGE_SUMMMARY = 'FACEBOOK_PAGE_SUMMMARY';
export const FACEBOOK_POST_REACH = 'FACEBOOK_POST_REACH';
export const INSTA_PAGE_SUMMMARY = 'INSTA_PAGE_SUMMMARY';
export const INSTA_POST_ENGAGEMENT = 'INSTA_POST_ENGAGEMENT';

//Facebook page fans online 
export const REQUEST_FACEBOOK_PAGE_FANS_ONLINE_SUCCESS = 'REQUEST_FACEBOOK_PAGE_FANS_ONLINE_SUCCESS';
export const REQUEST_FACEBOOK_PAGE_FANS_ONLINE_FAILURE = 'REQUEST_FACEBOOK_PAGE_FANS_ONLINE_FAILURE';

// Facebook post list
export const REQUEST_FACEBOOK_POST_LIST_SUCCESS = 'REQUEST_FACEBOOK_POST_LIST_SUCCESS';
export const REQUEST_FACEBOOK_POST_LIST_FAILURE = 'REQUEST_FACEBOOK_POST_LIST_FAILURE';
export const REQUEST_FACEBOOK_PAGE_INITIAL_SUCCESS = 'REQUEST_FACEBOOK_PAGE_INITIAL_SUCCESS';

//Facebook post Engagement
export const REQUEST_FACEBOOK_POST_ENGAGEMENT_SUCCESS = 'REQUEST_FACEBOOK_POST_ENGAGEMENT_SUCCESS';
export const REQUEST_FACEBOOK_POST_ENGAGEMENT_FAILURE = 'REQUEST_FACEBOOK_POST_ENGAGEMENT_FAILURE';

//Instagram followers
export const REQUEST_INSTA_AUDIENCE_CITY_SUCCESS = 'REQUEST_INSTA_AUDIENCE_CITY_SUCCESS';
export const REQUEST_INSTA_AUDIENCE_CITY_FAILURE = 'REQUEST_INSTA_AUDIENCE_CITY_FAILURE';

export const REQUEST_INSTA_AUDIENCE_COUNTRY_SUCCESS = 'REQUEST_INSTA_AUDIENCE_COUNTRY_SUCCESS';
export const REQUEST_INSTA_AUDIENCE_COUNTRY_FAILURE = 'REQUEST_INSTA_AUDIENCE_COUNTRY_FAILURE';

export const REQUEST_INSTA_AUDIENCE_GENDERAGE_SUCCESS = 'REQUEST_INSTA_AUDIENCE_GENDERAGE_SUCCESS';
export const REQUEST_INSTA_AUDIENCE_GENDERAGE_FAILURE = 'REQUEST_INSTA_AUDIENCE_GENDERAGE_FAILURE';

export const REQUEST_INSTA_AUDIENCE_LOCAL_SUCCESS = 'REQUEST_INSTA_AUDIENCE_LOCAL_SUCCESS';
export const REQUEST_INSTA_AUDIENCE_LOCAL_FAILURE = 'REQUEST_INSTA_AUDIENCE_LOCAL_FAILURE';

export const REQUEST_INSTA_FOLLOWERS_ONLINE_SUCCESS = 'REQUEST_INSTA_FOLLOWERS_ONLINE_SUCCESS';
export const REQUEST_INSTA_FOLLOWERS_ONLINE_FAILURE = 'REQUEST_INSTA_FOLLOWERS_ONLINE_FAILURE';

// Facebook Post ByType
export const REQUEST_FACEBOOK_POST_BY_TYPE_SUCCESS = 'REQUEST_FACEBOOK_POST_BY_TYPE_SUCCESS';
export const REQUEST_FACEBOOK_POST_BY_TYPE_ERROR = 'REQUEST_FACEBOOK_POST_BY_TYPE_ERROR';


// Instagram Post Analytics Post

export const CREATE_INSTAGRAM_POST_ANALYTICS_POST_SUCCESS = 'CREATE_INSTAGRAM_POST_ANALYTICS_POST_SUCCESS';
export const CREATE_INSTAGRAM_POST_ANALYTICS_POST_ERROR = 'CREATE_INSTAGRAM_POST_ANALYTICS_POST_ERROR';


// Instagram Post Analytics Story

export const CREATE_INSTAGRAM_POST_ANALYTICS_STORY_SUCCESS = 'CREATE_INSTAGRAM_POST_ANALYTICS_STORY_SUCCESS';
export const CREATE_INSTAGRAM_POST_ANALYTICS_STORY_ERROR = 'CREATE_INSTAGRAM_POST_ANALYTICS_STORY_ERROR';

//Linkedin Analytics
export const LINKEDIN_SHARE_ANALYTICS_SUCCESS = 'LINKEDIN_SHARE_ANALYTICS_SUCCESS';

export const LINKEDIN_SHARE_ANALYTICS_ERROR = 'LINKEDIN_SHARE_ANALYTICS_ERROR';
export const LINKEDIN_SHARE_LIST_SUCCESS = 'LINKEDIN_SHARE_LIST_SUCCESS';

export const LINKEDIN_SHARE_LIST_ERROR = 'LINKEDIN_SHARE_LIST_ERROR';
export const FACEBOOK_DEMOGRAPHICS = 'FACEBOOK_DEMOGRAPHICS';
export const LINKEDIN_VISITOR_SUCCESS = 'LINKEDIN_VISITOR_SUCCESS';
export const LINKEDIN_DEMOGRAPHIC_SUCCESS = 'LINKEDIN_DEMOGRAPHIC_SUCCESS';
export const LINKEDIN_FOLLOWER_SUCCESS = 'LINKEDIN_FOLLOWER_SUCCESS';
export const LINKEDI_NEW_FOLLOWER_SUCCESS = 'LINKEDI_NEW_FOLLOWER_SUCCESS';
export const LINKEDIN_NEW_FOLLOWER_ERROR = 'LINKEDIN_NEW_FOLLOWER_ERROR';
export const LINKEDIN_PAGE_VIEWS_SUCCESS = 'LINKEDIN_PAGE_VIEWS_SUCCESS';

// Standard Data 

export const STANDARD_DATA_SUCCESS = 'STANDARD_DATA_SUCCESS';
export const STANDARD_DATA_ERROR = 'STANDARD_DATA_ERROR';


// youtube analytics

export const YOUTUBE_OVERVIEW_SUCCESS = 'YOUTUBE_OVERVIEW_SUCCESS';
export const GET_YOUTUBE_VIDEOS_WITH_STATS_SUCCESS = 'GET_YOUTUBE_VIDEOS_WITH_STATS_SUCCESS';
export const YOUTUBE_REACH_SUCCESS = 'YOUTUBE_REACH_SUCCESS';
export const YOUTUBE_ENGAGEMENT_SUCCESS = 'YOUTUBE_ENGAGEMENT_SUCCESS';
export const YOUTUBE_ENGAGEMENT_EXTENDED_SUCCESS = 'YOUTUBE_ENGAGEMENT_EXTENDED_SUCCESS';

// Pinterest Analytics

export const PINTEREST_ACCOUNT_STATISTICS = 'PINTEREST_ACCOUNT_STATISTICS';
export const PINTEREST_TOP_POSTS = 'PINTEREST_TOP_POSTS';

//insta data

export const INSTA_FOLLOWER_COUNT = 'INSTA_FOLLOWER_COUNT';
export const INSTA_DEMOGRAPHICS = 'INSTA_DEMOGRAPHICS';
export const INSTA_ONLINE_FOLLOWER = 'INSTA_ONLINE_FOLLOWER';
export const REQUEST_USER_QUERY_SUCCESS = 'REQUEST_USER_QUERY_SUCCESS';
export const REQUEST_USER_QUERY_FAILURE = 'REQUEST_USER_QUERY_FAILURE';
export const SAVE_POST_SUCCESS = 'SAVE_POST_SUCCESS';

//fb,insta,yt dashboard posts
export const REQUEST_ALL_POSTS_FAILURE = "REQUEST_ALL_POSTS_FAILURE";
export const REQUEST_ALL_POSTS_SUCCESS = "REQUEST_ALL_POSTS_SUCCESS";
export const REQUEST_YT_POSTS_FAILURE = "REQUEST_YT_POSTS_FAILURE";
export const REQUEST_YT_POSTS_SUCCESS = "REQUEST_YT_POSTS_SUCCESS";
export const REQUEST_INSTA_POSTS_FAILURE = "REQUEST_INSTA_POSTS_FAILURE";
export const REQUEST_INSTA_POSTS_SUCCESS = "REQUEST_INSTA_POSTS_SUCCESS";

//brands list
export const REQUEST_BRANDS_LIST_SUCCESS = "REQUEST_BRANDS_LIST_SUCCESS";
export const REQUEST_BRANDS_LIST_FAILURE = "REQUEST_BRANDS_LIST_FAILURE";

//Notifications
export const REQUEST_NOTIFICATIONS_SUCCESS = "REQUEST_NOTIFICATIONS_SUCCESS";
export const REQUEST_NOTIFICATIONS_FAILURE = "REQUEST_NOTIFICATIONS_FAILURE";


//Mentions both read and unread
export const REQUEST_MENTION_SUCCESS = "REQUEST_MENTION_SUCCESS";
export const REQUEST_MENTION_START = "REQUEST_MENTION_START";
export const REQUEST_MENTION_FAILURE = "REQUEST_MENTION_FAILURE";
export const REQUEST_MENTIONS_START = "REQUEST_MENTIONS_START";
export const REQUEST_UNREAD_MENTION_SUCCESS = "REQUEST_UNREAD_MENTION_SUCCESS";
export const REQUEST_UNREAD_MENTION_FAILURE = "REQUEST_UNREAD_MENTION_FAILURE";
export const REQUEST_POST_TEXT_MESSAGE = 'REQUEST_POST_TEXT_MESSAGE';
export const REQUEST_POST_MESSAGES_EMPTY = 'REQUEST_POST_MESSAGES_EMPTY';


// logs manager
export const REQUEST_ALL_LOGS_SUCCESS = 'REQUEST_ALL_LOGS_SUCCESS';

// Tooltip for sidebar
export const ACTIVATE_TOOLTIP = "ACTIVATE_TOOLTIP";
export const DEACTIVATE_TOOLTIP = "DEACTIVATE_TOOLTIP";
export const HIDE_COMPOSE_SUB_MENU = "HIDE_COMPOSE_SUB_MENU";
export const ACTIVATE_ADD_BRAND_BUTTON_TOOLTIP = "ACTIVATE_ADD_BRAND_BUTTON_TOOLTIP";
export const DEACTIVATE_ADD_BRAND_BUTTON_TOOLTIP = "DEACTIVATE_ADD_BRAND_BUTTON_TOOLTIP";
export const NEW_ACCOUNT_ADDED = "NEW_ACCOUNT_ADDED";
export const DRAFT_LISTING_TOOLTIP = "DRAFT_LISTING_TOOLTIP";

// Instagram captions and hashtags generaiton
export const GENERATE_CAPTIONS_SUCCESS = "GENERATE_CAPTIONS_SUCCESS";
export const GENERATE_CAPTIONS_FALIURE = "GENERATE_CAPTIONS_FALIURE";
export const GENERATE_HASHTAGS_SUCCESS = "GENERATE_HASHTAGS_SUCCESS";
export const GENERATE_HASHTAGS_FAILURE = "GENERATE_HASHTAGS_FAILURE";

// Tiktok creator info
export const TIKTOK_CREATOR_INFO_SUCCESS = "TIKTOK_CREATOR_INFO_SUCCESS"
export const TIKTOK_CREATOR_INFO_FAILURE = "TIKTOK_CREATOR_INFO_FAILURE"

// Tiktok post status
export const TIKTOK_POST_STATUS_SUCCESS = "TIKTOK_POST_STATUS_SUCCESS"
export const TIKTOK_POST_STATUS_FAILURE = "TIKTOK_POST_STATUS_FAILURE"

//Text to image 
export const GENERATE_TEXT_TO_IMAGE = "GENERATE_TEXT_TO_IMAGE"
export const EDIT_TEXT_TO_IMAGE = "EDIT_TEXT_TO_IMAGE"

//Tiktok analytics
export const TIKTOK_ACCOUNT_SUMMARY = "TIKTOK_ACCOUNT_SUMMARY"
export const TIKTOK_POST_ENGAGEMENT = "TIKTOK_POST_ENGAGEMENT"
export const TIKTOK_DEMOGRAPHICS = "TIKTOK_DEMOGRAPHICS"

//Optimal Time Generation
export const GENERATE_OPTIMAL_TIME = "GENERATE_OPTIMAL_TIME"

//AI Image Download
export const AI_IMAGE_DOWNLOAD = "AI_IMAGE_DOWNLOAD"

//Youtube Post Status
export const YOUTUBE_POST_STATUS = "YOUTUBE_POST_STATUS"

//Youtube Post Status Change
export const YOUTUBE_POST_STATUS_CHANGE = "YOUTUBE_POST_STATUS_CHANGE"

//ChatGPT Credits
export const GET_USER_CHATGPT_CREDITS = "GET_USER_CHATGPT_CREDITS"
export const ADD_MORE_CHATGPT_CREDITS = "ADD_MORE_CHATGPT_CREDITS"

// Stripe Subscription Status
export const STRIPE_STATUS_SUCCESS = "STRIPE_STATUS_SUCCESS"
export const STRIPE_STATUS_FAILURE = "STRIPE_STATUS_FAILURE"

// Card Details 
export const CARD_DETAILS_FAILURE = "CARD_DETAILS_FAILURE"
export const CARD_DETAILS_FETCH_SUCCESS = "CARD_DETAILS_FETCH_SUCCESS"
export const CARD_DETAILS_UPDATE_SUCCESS = "CARD_DETAILS_UPDATE_SUCCESS"

//resume subscription
export const RESUME_STRIPE_SUBSCRIPTION_SUCCESS = "RESUME_STRIPE_SUBSCRIPTION_SUCCESS"
export const RESUME_STRIPE_SUBSCRIPTION_FAILURE = "RESUME_STRIPE_SUBSCRIPTION_FAILURE"

//fetch link preview metadata
export const FETCH_LINK_METADATA_SUCCESS = "FETCH_LINK_METADATA_SUCCESS"
export const FETCH_LINK_METADATA_FAILURE = "FETCH_LINK_METADATA_FAILURE"

//resubscribe subscription
export const RESUBSCRIBE_SUBSCRIPTION_SUCCESS = "RESUBSCRIBE_SUBSCRIPTION_SUCCESS"
export const RESUBSCRIBE_SUBSCRIPTION_FAILURE = "RESUBSCRIBE_SUBSCRIPTION_FAILURE"
